<template>
  <data-tables-template
    id="ResultsByQuestions"
    :headers="headersT"
    :datas="data[getField]"
    :is-loading="isLoading[getField]"
    :has-error="hasError[getField]"
    :error-msg="errorMsg"
    :error-empty="errorEmpty"
    :color="color"
    :items-per-page="Number(5)"
    class="elevation-1"
  />
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import DataTablesTemplate from './templates/DataTablesTemplate.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'ResultsByQuestions',

    /* Sous-composants utilisés par ce composant */
    components: {
      DataTablesTemplate,
    },

    /* Paramètres */
    props: {
      request: {
        type: String,
        default: '',
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      errorMsg: {
        type: String,
        default: '',
      },
      errorEmpty: {
        type: Object,
        default: function () {
          return {
            msg: 'Un problème est survenu.',
            icon: 'mdi-alert-rhombus-outline',
            color: 'error',
          }
        },
      },
      color: {
        type: String,
        default: 'primary',
      },
      thematic: {
        type: String,
        default: '',
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        isLoading: {
          perso: true,
          contexte: true,
          relations: true,
        },
        hasError: {
          perso: false,
          contexte: false,
          relations: false,
        },
        data: {
          perso: [],
          contexte: [],
          relations: [],
        },
        headers: [
          {
            text: 'Measure.Table.Headers.Title',
            value: 'title',
          },
          {
            text: 'Measure.Table.Headers.Thematic',
            value: 'thematic',
          },
          {
            text: 'Measure.Table.Headers.NumberOfAnswers',
            value: 'numberOfAnswers',
          },
          {
            text: 'Measure.Table.Headers.Score',
            value: 'score',
          },
        ],
      }
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      // Traduction des headers
      headersT: function () {
        return this.headers.map(header => {
          return {
            text: this.$t(header.text),
            value: header.value,
          }
        })
      },

      getField: function () {
        switch (this.thematic) {
          case 'Moi':
            return 'perso'
          case 'Mon Environnement':
            return 'contexte'
          case 'Mes Relations':
            return 'relations'
          default:
            return ''
        }
      },
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      request: function (newVal) {
        this.fetchAllData()
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchAllData()
    },

    /* Fonctions internes */
    methods: {
      // Récupération de toutes les données
      fetchAllData: function () {
        this.fetchResultsByQuestions('Perso')
        this.fetchResultsByQuestions('Contexte')
        this.fetchResultsByQuestions('Relations')
      },

      // Récuperation des données Résultats par Univers
      fetchResultsByQuestions: function (universe) {
        this.isLoading[universe.toLowerCase()] = true
        this.$Auth.httpRequest(
          'get',
          'api/dashboard/tables/resultsByQuestions' + universe + this.request,
        )
          .then(response => {
            if (
              !Array.isArray(response.data) ||
              (Array.isArray(response.data) && response.data.length < 1)
            ) {
              this.data[universe.toLowerCase()] = []
            } else {
              this.data[universe.toLowerCase()] = response.data
            }
            this.hasError[universe.toLowerCase()] = false
          })
          .catch((error) => {
            this.hasError[universe.toLowerCase()] = true
            if (this.isAdmin) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
            this.$emit('set-error', error)
          })
          .finally(() => {
            this.isLoading[universe.toLowerCase()] = false
          })
      },
    },
  }
</script>

<style>
  #ResultsByQuestions td, #ResultsByQuestions th {
    font-size: 0.9rem;
  }

  #ResultsByQuestions th {
    white-space: nowrap;
  }
</style>
